module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1141.55e1a6fa.png";